import React from 'react';
import PropTypes from 'prop-types';
import Date from "components/Display/ViewDate";
import YesNo from "components/Display/YesNo";
import Amount from "components/Display/Amount";

const PrincipalSettingTable = ({ data }) => {

  if (!data.legs){
    return (
      <div/>
    );
  }

  let principals = data.bond.legs[0].principals;
  return (
    <div className="calc-setting-table">
      <table className="table">
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="5" className="text-left calc-setting-table-header">Höfuðstólar</th>
        </tr>
        <tr>
          <th className="text-left">Gjalddagi</th>
          <th className="text-right">Eindagi</th>
          <th className="text-right">Útgefið</th>
          <th className="text-right">Reikna drv.</th>
          <th className="text-right">Upphæð</th>
        </tr>
        </thead>
        <tbody>
        {principals.map(function(item,i){
          return(
            <tr key={i}>
              <td className="text-right"><Date data={item.dueDate}/></td>
              <td className="text-right"><Date data={item.finalDueDate}/></td>
              <td className="text-right"><Date data={item.issueDate}/></td>
              <td className="text-center"><YesNo data={item.calculatePenaltyInterest}/></td>
              <td className="text-right"><Amount data={item.amount}/></td>
            </tr>);
        })}
        </tbody>
      </table>
    </div>
  );
};

PrincipalSettingTable.propTypes = {
  data: PropTypes.object,
};

export default PrincipalSettingTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/PrincipalSettingTable.js